
<script setup>
import { router } from '@inertiajs/vue3';
import JetNavLink from '@/Jetstream/NavLink.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const header_menu = router.page.props.ziggy.front_end_header_menu;

</script>

<template>
    <div v-if="$page.props.auth.user" class="sidebar-inner">

        <!-- Sidebar Navigation Menu Module -->
        <ul class="dashboard-navigation card sos-programme-form-card p-5 rounded-2xl" v-if="header_menu.length > 0">
            <li v-for="item in header_menu">
                <JetNavLink v-if="organisation" :href="route(urlNamePrefix+'page', {programme:programme.slug, organisation:organisation.slug, page:item.slug})">
                    {{item.title[$i18n.locale] ? item.title[$i18n.locale] : item.title[$i18n.fallbackLocale]}}
                </JetNavLink>
                <JetNavLink v-if="!organisation" :href="route(urlNamePrefix+'page', {programme:programme.slug, page:item.slug})">
                    {{item.title[$i18n.locale] ? item.title[$i18n.locale] : item.title[$i18n.fallbackLocale] }}
                </JetNavLink>
            </li>
        </ul>

        <!-- Sidebar Navigation Menu -->
        <ul class="dashboard-navigation core-dashboard-navigation pt-10 pb-5 border-b border-neutral-700">
            <li>
                <JetNavLink :href="route(urlNamePrefix+'dashboard')" :active="route().current('dashboard')">
                    <span class="material-icons-outlined material-icon mr-3">grid_view</span>
                    <span class="link-title">{{ $t('dashboard.sidebar.dashboard') }}</span>
                </JetNavLink>
            </li>
            <li>
                <JetNavLink :href="route(urlNamePrefix+'toolkit.view')">
                    <span class="material-icons-outlined material-icon mr-3">edit_note</span>
                    <span class="link-title">{{ $t('dashboard.sidebar.toolkit') }}</span>
                </JetNavLink>
            </li>
        </ul>

        <!-- Sidebar Navigation Menu -->
        <h4 class="font-bold" style="margin-top:10px;" v-if="organisation && organisation.pages.length > 0">{{organisation.name}}</h4>
        <ul class="dashboard-navigation pt-5 pb-5 border-b border-neutral-700" v-if="organisation && organisation.pages.length > 0">
            <li v-for="page in organisation.pages">
                <JetNavLink :href="route(urlNamePrefix+'page', {programme:programme.slug, organisation:organisation.slug, page:page.slug})">
                    {{page.title[$i18n.locale] ? page.title[$i18n.locale] : page.title[$i18n.fallbackLocale]}}
                </JetNavLink>
            </li>
        </ul>
        <h4 class="font-bold" style="margin-top:10px;" v-if="programme.pages.length > 0">{{programme.name}}</h4>
        <ul class="dashboard-navigation pt-5 pb-5 border-b border-neutral-700" v-if="(programme.pages.length > 0)">
            <li v-for="page in programme.pages">
                <JetNavLink v-if="organisation" :href="route(urlNamePrefix+'page', {programme:programme.slug, organisation:organisation.slug, page:page.slug})">
                    {{page.title[$i18n.locale] ? page.title[$i18n.locale] : page.title[$i18n.fallbackLocale]}}
                </JetNavLink>
                <JetNavLink v-if="!organisation" :href="route(urlNamePrefix+'page', {programme:programme.slug, page:page.slug})">
                    {{page.title[$i18n.locale] ? page.title[$i18n.locale] : page.title[$i18n.fallbackLocale]}}
                </JetNavLink>
            </li>
        </ul>
    </div>

</template>
